export default __webpack_public_path__ + "static/media/icon-activity-deleted.ce72cebc.svg";